import type { JSX } from 'react';
import CustomTypography from '@/components/Common/Typography';
import type { BiomarkerSelection, IBiomarkerData, IChartLaneLogScale } from '@/types/PatientDashboard/PatientTimeline.types';
import BiomarkerRow from './BiomarkerRow';
import { ChartLaneEmpty } from './ChartLane.styles';
import LaneError from './LaneError';
import ChartLaneLoading from './ChartLaneLoading';

interface IProps {
  data: IBiomarkerData;
  isLoading: boolean;
  hasFailure: boolean;
  selection: BiomarkerSelection;
  scale: IChartLaneLogScale;
  onToggle: (variantId: string) => void;
  onRetry: () => void;
  xPct: (date: string) => number;
}

export default function BiomarkerLaneBody({
  data,
  isLoading,
  hasFailure,
  selection,
  scale,
  onToggle,
  onRetry,
  xPct,
}: IProps): JSX.Element {
  if (isLoading) {
    return <ChartLaneLoading />;
  }

  if (hasFailure && !data.lines.length) {
    return <LaneError lane="chart" message="Could not load biomarker data." onRetry={onRetry} />;
  }

  if (!data.lines.length) {
    return (
      <ChartLaneEmpty>
        <CustomTypography variant="bodySmall">
          No reportable SNV biomarkers for this patient.
        </CustomTypography>
      </ChartLaneEmpty>
    );
  }

  return (
    <BiomarkerRow
      data={data}
      selection={selection}
      scale={scale}
      onToggle={onToggle}
      xPct={xPct}
    />
  );
}
